export enum TileSettingEvents {
    preview,
    addTile,
    initTileSettings,
    clearActiveTile,
    changeTile,
    deleteTile,
    pullTileSettings,
}

export enum TileColumnSettingEvents {
    COLUMN_GROUP_OPTIONS_CHANGE = 'COLUMN_GROUP_OPTIONS_CHANGE',
    COLUMN_GROUP_FILTER_CHANGE = 'COLUMN_GROUP_FILTER_CHANGE',
    COLUMN_GROUP_NOTE_TYPE_CHANGE = 'COLUMN_GROUP_NOTE_TYPE_CHANGE'
}

export enum TileOperations {
    DEFAULT = '',
    ADD = 'NEW',
    COPY = 'COPY',
    EDIT = 'EDIT'
}
